var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from "class-transformer";
import { safeAssign } from "./safe-assign";
export class RosterDailyResultsDTO {
    static { this.plainSerializable = true; }
    constructor(props) {
        this.employeeId = undefined;
        safeAssign(this, props);
    }
    static fromDailyResults(r) {
        const dto = Object.create(RosterDailyResultsDTO.prototype);
        dto.employeeId = r.employeeId;
        dto.date = r.date;
        dto.bonusesBalance = r.bonusesBalance;
        dto.timeBalance = r.timeBalance;
        dto.timeBalancePlanned = r.timeBalancePlanned;
        dto.vacationBalance = r.vacationBalance;
        dto.averages = { "13weeks": { base: { duration: r.averages["13weeks"].base.duration } } };
        return dto;
    }
}
__decorate([
    Expose(),
    __metadata("design:type", Object)
], RosterDailyResultsDTO.prototype, "employeeId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], RosterDailyResultsDTO.prototype, "date", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], RosterDailyResultsDTO.prototype, "bonusesBalance", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], RosterDailyResultsDTO.prototype, "timeBalance", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], RosterDailyResultsDTO.prototype, "timeBalancePlanned", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], RosterDailyResultsDTO.prototype, "vacationBalance", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], RosterDailyResultsDTO.prototype, "averages", void 0);
//# sourceMappingURL=roster-daily-results.dto.js.map